import React from 'react';
import { MoonOutlined, SunOutlined } from '@ant-design/icons';
import { IconButton } from 'components/common/icon-button';
import { useTheme } from 'hooks/use-theme';

export default function AppThemeSwitchButton() {
  const { isDarkTheme, setAppTheme } = useTheme();
  const toggle = () => setAppTheme(isDarkTheme ? 'light' : 'dark');

  return (
    <IconButton
      tooltipTitleId="toggle.theme"
      dataE2e="theme-switch-button"
      ariaLabel="Toggle theme"
      icon={isDarkTheme ? MoonOutlined : SunOutlined}
      // Figma's Icon button in Navigation/Top is the Small variant.
      size="small"
      onClick={toggle}
    />
  );
}
